import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'snackbar-message.online': {
    id: 'snackbar-message.online',
    defaultMessage: 'You’re back online! Your changes are now synced.',
    description:
      'This message is displayed to the user when their network connection is restored.',
  },
  'snackbar-message.online-mobile': {
    id: 'snackbar-message.online-mobile',
    defaultMessage: 'You’re back online!',
    description:
      'This message is displayed to the user when their network connection is restored on a mobile device.',
  },
  'snackbar-message.offline': {
    id: 'snackbar-message.offline',
    defaultMessage:
      'Looks like you’re offline. We’ll sync any offline changes when you’re back.',
    description:
      'This message is displayed to the user when their network connection is lost.',
  },
  'snackbar-message.offline-mobile': {
    id: 'snackbar-message.offline-mobile',
    defaultMessage: 'You’re offline.',
    description:
      'This message is displayed to the user when their network connection is lost on a mobile device.',
  },
  'snackbar-message.readOnlyModeActive': {
    id: 'snackbar-message.readOnlyModeActive',
    defaultMessage: 'You have view only access.',
    description:
      'This message is displayed to the user when the permissions have been updated and now they only have view access.',
  },
  'snackbar-message.viewToEditAccess': {
    id: 'snackbar-message.viewToEditAccess',
    defaultMessage: 'Access updated. You now have edit access.',
    description:
      'This message is displayed to the user when their permissions have been upgraded from view to edit access.',
  },
  'snackbar-message.editToViewAccess': {
    id: 'snackbar-message.editToViewAccess',
    defaultMessage: 'Access updated. You now have view access.',
    description:
      'This message is displayed to the user when their permissions have been downgraded from edit to view access.',
  },
  'snackbar-message.editToViewOfflineChangesDiscarded': {
    id: 'snackbar-message.editToViewOfflineChangesDiscarded',
    defaultMessage:
      'You no longer have edit access to this database. We reverted edits you made while offline.',
    description:
      'This message is displayed to the user when their network connection is restored and they no longer have edit access. Because they no longer have permission, their changes are discarded.',
  },
  'snackbar-message.viewingHistoricVersion': {
    id: 'snackbar-message.viewingHistoricVersion',
    defaultMessage: 'Viewing {versionName}',
    description:
      'This message is displayed to the user when they are viewing a historic version in the version history.',
  },
});
